import { IconSvg, IconSvgProps } from "./icon"

export default function NewChat(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M9.93 6.098c-1.119.052-2.214.173-3.282.296a2.692 2.692 0 0 0-2.36 2.366c-.154 1.386-.303 2.82-.303 4.285 0 1.467.149 2.9.303 4.288a2.693 2.693 0 0 0 2.36 2.363c1.393.16 2.833.321 4.307.321 1.474 0 2.914-.16 4.308-.321a2.693 2.693 0 0 0 2.358-2.363 49.98 49.98 0 0 0 .273-3.06m-1.898-9.598-4.738 5.374-.648 3.054c-.105.491.408.956.887.805l3.037-.954 4.894-5.15c.813-.855.67-2.286-.313-3.156-.96-.849-2.357-.838-3.119.026v.001Z" />
    </IconSvg>
  )
}
